import { PAGE_LIST_TYPES, PAGE_BULK_ACTIONS } from '../constants/list-types';

/**
 * @param {string} listType
 * @param {object} item
 * @returns {object} 'Bulk Actions' available for the specific list
 */

export const listActions = (
    listType,
    memberId,
    selectedFilterBar,
    count = 0,
    t
) => {
    const actions = {
        [PAGE_LIST_TYPES.SELLER_ACTIVE]: () => {
            switch (selectedFilterBar) {
                default:
                    return {
                        isCheckboxActive: item =>
                            item && item.bidInformation.bidCount === 0,
                        bulkCssClass: 'danger',
                        label: t('myt_action_cancelListingsLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.ACTIVE_CANCEL,
                        modal: {
                            icon: 'warning',
                            heading: t(
                                'myt_action_cancelListingsModalHeading',
                                { count: count, itemCount: count }
                            ),
                            message: t(
                                'myt_action_cancelListingsModalMessage',
                                { count: count }
                            ),
                            confirmButtonText: t(
                                'myt_action_cancelListingsModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_cancelListingsModalCancelButtonText'
                            ),
                            dismissable: true
                        },
                        idType: 'itemId'
                    };
            }
        },

        [PAGE_LIST_TYPES.SELLER_NOT_SOLD]: () => {
            switch (selectedFilterBar) {
                default:
                    return {
                        isCheckboxActive: item => {
                            if (!item) {
                                return false;
                            }
                            if (item.listing.restart.hasRestartedChild) {
                                return false;
                            }
                            return !item.isArchived;
                        },
                        /*
                         * @todo: confirm this
                         */
                        bulkCssClass: 'primary',
                        label: t('myt_action_restartListingsLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.UNSOLD_RESTART,
                        modal: {
                            heading: t(
                                'myt_action_restartListingsModalHeading',
                                { count: count, itemCount: count }
                            ),
                            dismissable: true,
                            wide: true,
                            confirmButtonText: t(
                                'myt_action_restartListingsModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_restartListingsModalCancelButtonText'
                            ),
                            headingCSS: 'messaging-modal-title-with-line',
                            messageAlignment: 'left',
                            cssClass: false
                        },
                        idType: 'itemId'
                    };
            }
        },

        [PAGE_LIST_TYPES.BUYER_ACTIVE_ITEMS]: () => {
            switch (selectedFilterBar) {
                case 'BuyerHidden':
                    return {
                        isCheckboxActive: item => {
                            return (
                                (item &&
                                    item.caller.leadingBidRemoved === true) ||
                                (item.bidInformation.leadingBidder &&
                                    item.bidInformation.leadingBidder.id !==
                                        memberId)
                            );
                        },
                        bulkCssClass: 'primary',
                        label: t(
                            'myt_action_showBuyerHiddenActiveListingsLabel'
                        ),
                        bulkAction: PAGE_BULK_ACTIONS.BUYER_SHOW_ACTIVE,
                        modal: {
                            heading: t(
                                'myt_action_showBuyerHiddenActiveListingsModalHeading',
                                { count: count, itemCount: count }
                            ),
                            message: t(
                                'myt_action_showBuyerHiddenActiveListingsModalMessage',
                                { count: count }
                            ),
                            dismissable: true,
                            wide: false,
                            confirmButtonText: t(
                                'myt_action_showBuyerHiddenActiveListingsModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_showBuyerHiddenActiveListingsModalCancelButtonText'
                            ),
                            icon: 'warning',
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                case 'BuyerNotHidden':
                    return {
                        isCheckboxActive: item => {
                            return (
                                (item &&
                                    item.caller?.leadingBidRemoved === true) ||
                                (item.bidInformation.leadingBidder &&
                                    (item.bidInformation.leadingBidder.id !==
                                        memberId ||
                                        item.reservePriceReached === false))
                            );
                        },
                        bulkCssClass: 'primary',
                        label: t('myt_action_hideListingsLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.BUYER_HIDE_ACTIVE,
                        modal: {
                            heading: t('myt_action_hideListingsModalHeading', {
                                count: count,
                                itemCount: count
                            }),
                            dismissable: true,
                            wide: false,
                            icon: 'warning',
                            confirmButtonText: t(
                                'myt_action_hideListingsModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_hideListingsModalCancelButtonText'
                            ),
                            message: t('myt_action_hideListingsModalMessage', {
                                count: count
                            }),
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                default:
                    return undefined;
            }
        },

        [PAGE_LIST_TYPES.BUYER_PURCHASES]: () => {
            switch (selectedFilterBar) {
                case 'AllPurchases':
                case 'BuyerNotPaid':
                    return {
                        isCheckboxActive: item =>
                            item &&
                            item.transaction &&
                            item.transaction.buyerState &&
                            item.transaction.buyerState.paid !== true,
                        bulkCssClass: 'primary',
                        label: t('myt_action_markListingsAsPaidLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.BUYER_MARK_PAID,
                        modal: {
                            heading: t(
                                'myt_action_markListingsAsPaidModalHeading',
                                { count: count, itemCount: count }
                            ),
                            message: '',
                            dismissable: true,
                            wide: false,
                            confirmButtonText: t(
                                'myt_action_markListingsAsPaidModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_markListingsAsPaidModalCancelButtonText'
                            ),
                            icon: 'warning',
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                case 'BuyerHidden':
                    return {
                        isCheckboxActive: () => {
                            return true;
                            // return item && (item.caller.leadingBidRemoved === true) || (item.bidInformation.leadingBidder && item.bidInformation.leadingBidder.id !== memberId) ? true : false;
                        },
                        bulkCssClass: 'primary',
                        label: t('myt_action_showBuyerHiddenPurchasesLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.PURCHASES_SHOW,
                        modal: {
                            heading: t(
                                'myt_action_showBuyerHiddenPurchasesModalHeading',
                                { count: count, itemCount: count }
                            ),
                            message: t(
                                'myt_action_showBuyerHiddenPurchasesModalMessage',
                                { count: count }
                            ),
                            dismissable: true,
                            wide: false,
                            confirmButtonText: t(
                                'myt_action_showBuyerHiddenPurchasesModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_showBuyerHiddenPurchasesModalCancelButtonText'
                            ),
                            icon: 'warning',
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                default:
                    return undefined;
            }
        },

        [PAGE_LIST_TYPES.BUYER_ITEMS_LOST]: () => {
            switch (selectedFilterBar) {
                case 'ItemsLostNotHidden':
                    return {
                        isCheckboxActive: () => true,
                        bulkCssClass: 'primary',
                        label: t('myt_action_hideListingsLabel'),
                        bulkAction: PAGE_BULK_ACTIONS.BUYER_HIDE_ACTIVE,
                        modal: {
                            heading: t('myt_action_hideListingsModalHeading', {
                                count: count,
                                itemCount: count
                            }),
                            dismissable: true,
                            wide: false,
                            icon: 'warning',
                            confirmButtonText: 'Ja',
                            cancelButtonText: 'Nej',
                            message: t('myt_action_hideListingsModalMessage', {
                                count: count
                            }),
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                case 'ItemsLostHidden':
                    return {
                        isCheckboxActive: () => true,
                        bulkCssClass: 'primary',
                        label: t(
                            'myt_action_showBuyerHiddenActiveListingsLabel'
                        ),
                        bulkAction: PAGE_BULK_ACTIONS.BUYER_SHOW_ACTIVE,
                        modal: {
                            heading: t(
                                'myt_action_showBuyerHiddenActiveListingsModalHeading',
                                { count: count, itemCount: count }
                            ),
                            message: t(
                                'myt_action_showBuyerHiddenActiveListingsModalMessage',
                                { count: count }
                            ),
                            dismissable: true,
                            wide: false,
                            confirmButtonText: t(
                                'myt_action_showBuyerHiddenActiveListingsModalConfirmButtonText'
                            ),
                            cancelButtonText: t(
                                'myt_action_showBuyerHiddenActiveListingsModalCancelButtonText'
                            ),
                            icon: 'warning',
                            headingCSS: 'messaging-modal-title',
                            messageAlignment: 'center',
                            cssClass: false
                        }
                    };
                default:
                    return undefined;
            }
        },

        default: () => ({})
    };

    return actions[listType] ? actions[listType]() : actions['default']();
};
